// extracted by mini-css-extract-plugin
export default {"switchInputWrapper":"GroupInput_switchInputWrapper__2UCH9","switchLabel":"GroupInput_switchLabel__lWCBk"};